import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronRight, Plus, ShieldCheck } from 'lucide-react';
import { Logo } from './Logo';
import { navItems } from './data';
import { useApp } from './store';
interface SidebarProps {
  open: boolean;
  onClose: () => void;
  onCreatePost: () => void;
}
export function Sidebar({
  open,
  onClose,
  onCreatePost
}: SidebarProps) {
  const {
    config,
    isAdmin
  } = useApp();
  const visibleItems = navItems.filter(item => !config.hiddenNav.includes(item.label));
  return <>
      {/* Mobile overlay */}
      {open && <div className="fixed inset-0 bg-navy-900/50 z-40 lg:hidden" onClick={onClose} aria-hidden="true" data-id="element-940" />}

      <aside className={`fixed lg:sticky top-0 left-0 z-50 h-screen w-64 bg-navy-600 flex flex-col shrink-0 transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-941">
        {/* Brand */}
        <div className="h-20 flex items-center justify-center border-b border-white/10 px-5 shrink-0" data-id="element-942">
          <NavLink to="/" onClick={onClose} aria-label="Independence Home Loans home" data-id="element-943">
            <Logo className="h-14 max-w-full" data-id="element-944" />
          </NavLink>
        </div>

        {/* Nav */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-945">
          {visibleItems.map(item => {
          const Icon = item.icon;
          return <NavLink key={item.label} to={item.to} end={item.end} onClick={onClose} className={({
            isActive
          }) => `w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors group ${isActive ? 'bg-gold-500 text-navy-900' : 'text-navy-100 hover:bg-white/10 hover:text-white'}`} data-id="element-946">
                {({
              isActive
            }) => <>
                    <Icon className="w-5 h-5 shrink-0" data-id="element-947" />
                    <span className="flex-1 text-left" data-id="element-948">{item.label}</span>
                    {item.badge ? <span className={`text-xs font-bold px-1.5 py-0.5 rounded-full ${isActive ? 'bg-navy-900 text-gold-400' : 'bg-gold-500 text-navy-900'}`} data-id="element-949">
                        {item.badge}
                      </span> : <ChevronRight className={`w-4 h-4 transition-opacity ${isActive ? 'opacity-60' : 'opacity-0 group-hover:opacity-60'}`} data-id="element-950" />}
                  </>}
              </NavLink>;
        })}

          {isAdmin && <div className="pt-3 mt-3 border-t border-white/10" data-id="element-951">
              <p className="px-3 pb-1 text-[0.65rem] font-bold uppercase tracking-widest text-navy-200" data-id="element-952">
                Admin
              </p>
              <NavLink to="/admin" onClick={onClose} className={({
            isActive
          }) => `w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors group ${isActive ? 'bg-gold-500 text-navy-900' : 'text-navy-100 hover:bg-white/10 hover:text-white'}`} data-id="element-953">
                {({
              isActive
            }) => <>
                    <ShieldCheck className="w-5 h-5 shrink-0" data-id="element-954" />
                    <span className="flex-1 text-left" data-id="element-955">Site Admin</span>
                    <ChevronRight className={`w-4 h-4 transition-opacity ${isActive ? 'opacity-60' : 'opacity-0 group-hover:opacity-60'}`} data-id="element-956" />
                  </>}
              </NavLink>
            </div>}
        </nav>

        {/* Create post CTA */}
        <div className="p-3 border-t border-white/10 shrink-0" data-id="element-957">
          <button onClick={onCreatePost} className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-bold text-navy-900 bg-white rounded-lg hover:bg-gold-100 transition-colors" data-id="element-958">
            <Plus className="w-4 h-4" data-id="element-959" />
            Create Post
          </button>
        </div>
      </aside>
    </>;
}